<div class="modal-header">
  <h5 class="modal-title">{{ options.title }} </h5>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col">
      <span *ngIf="options.unique">{{'lang.modal.uniquehint' | translate}}</span>
      <input [(ngModel)]="selectedOption" type="text" class="form-control" (keyup)="checkPattern()"
             [ngClass]="{'border-green' : isPatternMatched, 'border-red' : !isPatternMatched}">
    </div>
  </div>
  <div *ngIf="!isPatternMatched" class="row">
    <div class="col">
      <div class="warning">{{'lang.globals.valueInvalid' | translate}}</div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <sb-button classes="btn-primary" (click)="ok()" [disabled]="!checkOkEnabled() || !isPatternMatched">{{ 'lang.globals.ok' | translate }}
  </sb-button>
  <sb-button classes="btn-default" (click)="cancel()">{{ 'lang.globals.cancel' | translate }}
  </sb-button>
</div>
